import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import { getFormattedLocalDateTime } from '@helpers/dates';
import { ArticleHeader } from './ArticleHeader';
import { articleContentAreaStyles as classes } from './styleObjects/ArticleContentArea';
import { RenderChips } from '@components/BlogSection/BlogComponents/Shared/RenderChips';
import { MediaContact } from './PressRoomHome/MediaContact';
import { RenderedArticle } from './Articles/RenderedArticle';
import { getTranslation } from '@helpers/languageTranslations';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { useTranslation } from '@stateManagement/TranslationContext';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { Heading, Text } from '@web-for-marketing/react-ui';
import { PublicDateTime } from './PublicDateTime';

export function PressReleaseCard({ pressRelease }) {
    const [selectedLanguage] = useAtom(selectedLanguageAtom);
    const { mediaUrlPrefix } = useStaticValues();
    const { selectedLanguageTranslation } = useTranslation();
    const pressReleaseTranslation = getTranslation(selectedLanguageTranslation, 'pressRelease');

    return (
        <section css={classes.container} data-testid='pressReleaseCardTestId'>
            <Grid container>
                <Grid item xs={12}>
                    <Heading variant='h1' color='primary' css={classes.title}>
                        {pressRelease.title}
                    </Heading>
                </Grid>
                <Grid item xs={12}>
                    <PublicDateTime>
                        <Text variant='body1' css={classes.publishedDate}>
                            {pressReleaseTranslation.publishedOn}{' '}
                            {getFormattedLocalDateTime(pressRelease.publishedDateUtc, 'LL', selectedLanguage)}
                        </Text>
                    </PublicDateTime>
                </Grid>
                <Divider css={classes.dividerTop} />
                <Grid item xs={12}>
                    <Heading variant='h2' css={classes.subHeading}>
                        {pressRelease.description}
                    </Heading>
                </Grid>
                {pressRelease.imageUrl || pressRelease.videoUrl ? (
                    <Grid item xs={12} css={classes.media}>
                        <ArticleHeader article={pressRelease} />
                    </Grid>
                ) : null}
                <Grid item css={classes.content} xs={12}>
                    <RenderedArticle content={pressRelease.htmlContent} mediaUrlPrefix={mediaUrlPrefix} />
                </Grid>
                {pressRelease.tags && pressRelease.tags.length ? (
                    <Grid item css={classes.tags} xs={12}>
                        <RenderChips chips={pressRelease.tags} />
                    </Grid>
                ) : null}
                <Grid item xs={12}>
                    <Divider css={classes.dividerBottom} />
                </Grid>
                <MediaContact translations={pressReleaseTranslation} />
            </Grid>
        </section>
    );
}

PressReleaseCard.propTypes = {
    pressRelease: PropTypes.objectOf(Object).isRequired,
};
